<template>
  
</template>

<script>
export default {
    created(){
       sessionStorage.setItem('name',"verifyUser");
       this.$router.push('/chinajoyticket/phone');
    }
}
</script>

<style>

</style>